module.exports = __webpack_public_path__ + "img/MENU_support-faq.aafe6edc.svg";